<template>
  <v-card>
    <v-card-title class="text-h6">
      {{ $t("Hoàn thành") }}
    </v-card-title>

    <v-card-text>
      <v-file-input
        v-model="file"
        append-icon="mdi-paperclip"
        prepend-icon=""
        dense
        outlined
        hide-details
        multiple
        class="c-input-small"
        label="*Ảnh phụ lục"
        accept="image/*"
        @change="onInputFileChange"
      ></v-file-input>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click="close">
        {{ $t("Hủy") }}
      </v-btn>
      <v-btn color="green darken-1" text @click="finishExchange">
        {{ $t("Xác nhận") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { compress } from "image-conversion";
import { httpClient } from "@/libs/http";
import moment from "moment";

export default {
  name: "UploadDialog",
  props: {
    order: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    isLoading: false,
    file: null,
    images: [],
  }),
  methods: {
    close() {
      this.$emit("close", true);
    },

    async finishExchange() {
      try {
        await httpClient.post("/order/v1/exchange-finish", {
          images: this.images,
          id_order: this.order.id,
        });

        this.isLoading = false;
        document.getElementById("success_sound_player").play();
        this.$emit("finished");
        this.close();
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
        this.isLoading = false;
        document.getElementById("error_sound_player").play();
      }
    },

    async onInputFileChange(files) {
      if (this.isLoading) {
        this.$vToastify.warning(this.$t("messages.loading"));
        return false;
      }

      this.isLoading = true;

      const images = [];
      for (let i = 0; i < files.length; i++) {
        const url = await this.uploadFile(files[i]);
        images.push(url);
      }

      this.isLoading = false;

      this.images = [...images];
    },

    async uploadFile(file) {
      const resBlob = await compress(file, {
        quality: 0.85,
        width: 1024,
        type: "image/jpeg",
      });
      const newFile = new File(
        [resBlob],
        `${moment().unix()}_${this.generateRandomString(10)}.jpg`,
        { type: "image/jpeg" }
      );
      let fd = new FormData();
      fd.append("file", newFile);
      const { data } = await httpClient.post(`/common/v1/upload-image`, fd);
      return data;
    },
  },
};
</script>
